import { Component, Inject, LOCALE_ID, Optional } from '@angular/core';
import { SERVER_URL } from 'projects/qo-commons/src/tokens/server-url.token';
import { NavigationService } from '../../services/navigation/navigation.service';
import { EnvironmentService, EnvironmentSettings } from '../../services/environment/environment.service';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'qo-footer',
    templateUrl: './footer.component.html',
    imports: [MatRipple, RouterLink, DatePipe]
})
export class FooterComponent {
    
    NavigationService = NavigationService;
    environmentSettings: EnvironmentSettings;
    today = new Date();
    
    constructor(@Optional() @Inject(SERVER_URL) public serverUrl: string, environmentService: EnvironmentService, @Inject(LOCALE_ID) public locale: string) {
        this.environmentSettings = environmentService.settings;
    }
    
}
